import { hydrateRoot } from 'react-dom/client';
import { RelayEnvironmentProvider } from 'react-relay';
import serverVars from 'server-vars';

import { initializeDBL } from 'dibs-buyer-layout/src/entries/index';

import { getRelayEnvironment } from '../utils/relayModernEnvironment';
import { NftExhibitionWrapper } from './NftExhibitionWrapper';
import { trackPageview } from 'dibs-tracking';

const environment = getRelayEnvironment({
    ...serverVars.get('dbl.relayData'),
});
const variables = serverVars.get('relayVariables');

initializeDBL().then(({ store }: { store: $TSFixMe }) => {
    hydrateRoot(
        document.getElementById('js-root') as HTMLElement,
        <RelayEnvironmentProvider environment={environment}>
            <NftExhibitionWrapper
                locale={serverVars.get('intlVariables.locale')}
                deviceType={serverVars.get('deviceType')}
                store={store}
                isExhibitionLanding={serverVars.get('isExhibitionLanding') === 'true'}
                variables={variables}
            />
        </RelayEnvironmentProvider>
    );
    trackPageview({
        additional: {
            pageType: 'Other',
            pageSubType: `NFT Marketplace`,
        },
    });
});
